/* eslint-disable no-shadow */
import { storePagination, pagination, sorting } from '@/mixins'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  // Resumo agregado por loja (uma linha por loja)
  // [{ storeId, storeName, pendingCount, totalValue }]
  summaries: [],
  // Totais agregados de todas as lojas (linha de total do card)
  summaryFields: {},
  paging: { ...pagination.data().paging, pageSize: 5 },
  sorting: { ...sorting.data().sorting, sortBy: 'storeName', sortDesc: false },
})

export default {
  namespaced: true,

  state: getInitialState(),

  mutations: {
    ...storePagination.mutations,

    SET_SUMMARIES(state, summaries) {
      state.summaries = summaries
    },
    SET_SUMMARY_FIELDS(state, summaryFields) {
      state.summaryFields = summaryFields
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchPendingInvoices({ state, commit }) {
      // O backend já restringe às lojas do usuário logado (via contexto autenticado)
      const { data } = await axios.get('/api/invoices-received/pending-alert', {
        params: {
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_SUMMARIES', data.results)
      commit('SET_SUMMARY_FIELDS', data.summaryFields || {})
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },
  },
}
